// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { OrderComplaintModel, OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import RequestOrderComplaintState from "@store/Framework/Store/Greif/Pages/RequestOrderComplaint/RequestOrderComplaintState";
import { Draft } from "immer";

const initialState: RequestOrderComplaintState = {
    orderLine: null,
};

const actions = {
    "Greif/PagesReducer/RequestOrderComplaint/BeginSendOrderComplaintRequest": (
        draft: Draft<RequestOrderComplaintState>,
    ) => {
        draft.resultMessage = undefined;
    },
    "Greif/PagesReducer/RequestOrderComplaint/CompleteSendOrderComplaintRequest": (
        draft: Draft<RequestOrderComplaintState>,
        action: { result?: OrderComplaintModel },
    ) => {
        draft.resultMessage = action.result?.message;
    },
    "Greif/PagesReducer/RequestOrderComplaint/SetOrderLines": (
        draft: Draft<RequestOrderComplaintState>,
        action: { orderLine: OrderLineModel | null },
    ) => {
        draft.orderLine = action.orderLine;
    },
    "Greif/PagesReducer/RequestOrderComplaint/SetQtyNonConformancies": (
        draft: Draft<RequestOrderComplaintState>,
        action: { qtyNonConformancies: number },
    ) => {
        draft.qtyNonConformancies = action.qtyNonConformancies;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifOrderComplaintPagesActions = Parameters<typeof reducer>[1];
export default reducer;
